import React, { useEffect, useState, useCallback } from 'react';
import {Box} from "@chakra-ui/react";
import {useError} from "../../../../Context/ErrorContext/ErrorContext";
import {fetchAllFaqs} from "../FaqsAPI";
import FaqTableTopBar from "./FaqTableTopBar";
import FaqTable from "./FaqTable";

const FaqContainer = () => {
    const [faqs, setFaqs] = useState([]);
    const [filterOptions, setFilterOptions] = useState({});
    const [error, setError] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const { handleError } = useError();

    const refetchFaqData = useCallback(async (options = {}) => {
        setDataLoaded(false);
        try {
            const data = await fetchAllFaqs(pageNumber, 10, filterOptions, handleError);
            setFaqs(data.faqs);
            setTotalPages(data.totalPages);
            setError('');
            setDataLoaded(true);
        } catch (error) {
            setError(error.message);
            setFaqs([]);
            setTotalPages(0);
        }
    }, [pageNumber, filterOptions, handleError]);

    useEffect(() => {
        refetchFaqData();
    }, [fetchTrigger, refetchFaqData, refreshFlag, totalPages, fetchTrigger, filterOptions]);

    if (!faqs) {
        return (
            <Box textAlign="center" my="4" p="4" color="red.600" bg="blue.50">
                <p>Service is down...</p>
            </Box>
        );
    }

    return (
        <>
            <FaqTableTopBar
                refetchFaqData={refetchFaqData}
                setPageNumber={setPageNumber}
                setFilterOptions={setFilterOptions}
                setFetchTrigger={setFetchTrigger}
            />
            <FaqTable
                faqs={faqs}
                setFaqs={setFaqs}
                error={error}
                pageNumber={pageNumber}
                setRefreshFlag={setRefreshFlag}
                setPageNumber={setPageNumber}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                filterOptions={filterOptions}
                dataLoaded={dataLoaded}
                refetchFaqData={refetchFaqData}
            />
        </>
    );
};

export default FaqContainer;
